import React, { useState } from 'react';
import '../../../styles/components/management/steps/Forms.css';

const API_BASE = process.env.REACT_APP_API_BASE;


export default function StepForm({ unitId, initial, onClose, onSaved }) {
  const isNew = !initial?.STEP_TEMPLATE_ID;

  // Form state
  const [title, setTitle]   = useState(initial?.TITLE ?? '');
  const [desc, setDesc]     = useState(initial?.DESCRIPTION ?? '');
  const [color, setColor]   = useState(initial?.COLOR ?? '#28a745');
  const [order, setOrder]   = useState(initial?.STEP_ORDER ?? 1);

  const saveTemplate = async () => {
    const payload = { title, description: desc, color };

    if (isNew) {
      const res = await fetch(`${API_BASE}/app/API/rbmgt/step_template.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).then(r => r.json());

      return res?.id ?? null;
    }

    await fetch(`${API_BASE}/app/API/rbmgt/step_template.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: initial.STEP_TEMPLATE_ID, ...payload }),
    });

    return initial.STEP_TEMPLATE_ID;
  };

  const linkToUnit = async (templateId) => {
    const method = isNew ? 'POST' : 'PUT';

    await fetch(`${API_BASE}/app/API/rbmgt/unit_step.php`, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        unit_id: unitId,
        step_template_id: templateId,
        step_order: order,
      }),
    });
  };

  const handleSave = async () => {
    try {
      const templateId = await saveTemplate();
      if (!templateId) throw new Error('Failed to save template');

      await linkToUnit(templateId);
      onSaved(isNew, templateId, order);
    } catch (err) {
      console.error('Step save error:', err);
      alert('An error occurred while saving. Please try again.');
    }
  };

  return (
    <div className="modal">
      <h3>{isNew ? 'Add Step' : 'Edit Step'}</h3>

      <label>
        Step Number
        <input
          type="number"
          min="1"
          value={order}
          onChange={e => setOrder(Math.max(1, parseInt(e.target.value) || 1))}
        />
      </label>

      <label>
        Title
        <input
          type="text"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
      </label>

      <label>
        Description
        <textarea
          value={desc}
          onChange={e => setDesc(e.target.value)}
        />
      </label>

      <label>
        Color
        <input
          type="color"
          value={color}
          onChange={e => setColor(e.target.value)}
        />
      </label>

      <div className="modal-buttons">
        <button onClick={handleSave}>
          {isNew ? 'Create' : 'Save'}
        </button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
